import { Product } from './product';
import { Template } from './template';

export class CartProduct {
  product: Product;
  product_id: string;
  template_id: number = null;
  template: Template;
  template_options: Template[] = [];
  size_id: number = null;
  allow_local_price = false;
  require_local_price = false;
  require_store_price = false;
  amount: number = 1;
  v1_local_price: number;
  v2_local_price: number;
  v1_store_price: number;
  v2_store_price: number;
  show_price_component: boolean = false;

  constructor(product: Product, cartProduct: CartProduct = null) {
    this.product = product;
    this.product_id = product.id;
    this.amount = 1;
    if (cartProduct !== null) {
      this.amount = cartProduct.amount;
      this.size_id = cartProduct.size_id;
      this.template_id = cartProduct.template_id;
      this.template_options = cartProduct.template_options;
    }
  }

  hasValidAttribute(attribute: any) {
    return (!isNaN(attribute) && attribute !== null);
  }

  hasValidAttributeForLocalPrice():boolean {
     if (this.require_local_price) {
        return (this.v1_local_price >= 1);
      }
    return true;
  }

  hasValidAttributeForStorePrice():boolean {
     if (this.require_store_price) {
        return (this.v1_store_price >= 1);
      }
    return true;
  }

  isValid(): boolean {
    return (this.hasValidAttribute(this.size_id) &&
      this.hasValidAttribute(this.template_id) &&
      this.hasValidAttribute(this.amount)) &&
      this.hasValidAttributeForLocalPrice();
  }
}



// WEBPACK FOOTER //
// /app/src/app/_models/cart-product.ts